import React,{ useEffect, useState, useCallback } from "react";
import "./user.css";
import { useDispatch, useSelector } from 'react-redux';
import { fetchThemeData } from '../../admin/themeSlice';
import { requestBackToMainGrid } from '../uiSlice';
import { useLocation, useNavigate } from "react-router-dom";
import { s3CssUrl } from '../../utils/s3PublicUrl';

function USER({children }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
    const location = useLocation();

    const { companyLogoUrl, backButtonUrl, mainDaySubViewOpen, backButtonHidden } = useSelector(
      (state) => state.ui
    );
    const [logoUrl,setLogoUrl]=useState("");
    const [backUrl,setBackUrl]=useState("");

    const { user } = useSelector(state => state.auth);
    const { status: themeStatus, data: themeData } = useSelector(state => state.theme);
 
    const fromMobileAppInUrl =
      String(new URLSearchParams(location.search).get("fromMobileApp") || "").toLowerCase() ===
      "true";
    const fromMobileAppInUser = String(user?.fromMobileApp || "").toLowerCase() === "true";
    const persistedFromMobileApp = (() => {
      try {
        const persisted = JSON.parse(
          sessionStorage.getItem("userData") || "{}"
        );
        return String(persisted?.fromMobileApp || "").toLowerCase() === "true";
      } catch {
        return false;
      }
    })();
    const isFromMobileApp = fromMobileAppInUrl || fromMobileAppInUser || persistedFromMobileApp;


  const applyCustomTheme = (theme) => {
    if (!theme) return;
    const set = (k, v) =>
      document.documentElement.style.setProperty(k, v != null ? String(v) : "");

    // Core theme variables (no hardcoded defaults; they come from themeset)
    set("--text-color", theme.text_color);
    set("--box-bg-color", theme.box_bg_color);
    set("--box-text-color", theme.box_text_color);
    set("--popup-color", theme.popup_color);

    // Legacy variables (still used in a few places)
    set("--ui-color-1", theme.ui_color_1);
    set("--ui-color-2", theme.ui_color_2);
    set("--option-color", theme.option_color);
    set("--option-text-color", theme.option_text_color);

    // Desktop background (used for modal backgrounds)
    set("--desktop-bg-image", s3CssUrl(theme.background_desk));
  };
    
  useEffect(() => {
      if (!/^\/login(?:\/)?$/.test(location.pathname)) {
        if (themeStatus === "idle") {
          dispatch(fetchThemeData({ themeId: null }));
        }
      }
  }, [themeStatus, dispatch, location.pathname]);

  useEffect(()=>{
    setBackUrl(backButtonUrl);
    setLogoUrl(companyLogoUrl);
  },[backButtonUrl,companyLogoUrl])


  useEffect(() => {
    if (themeStatus !== 'succeeded' || !themeData) return undefined;
    // themeset fields are on themeData root (not only themeData.colors)
    applyCustomTheme(themeData);

    // USER only wraps player routes, so set the body background directly instead of
    // gating on body.common-bg: App adds that class in a parent effect, which runs
    // *after* this one, so the check failed when arriving with the theme already loaded
    // (e.g. coming from /admin) and the background was never applied.
    const body = document.body;
    const applyBg = () => {
      const bg =
        (window.innerWidth <= 768 ? themeData.background_mob : themeData.background_desk) ||
        themeData.background_desk ||
        themeData.background_mob;
      body.style.backgroundImage = s3CssUrl(bg);
    };
    applyBg();
    window.addEventListener('resize', applyBg);
    return () => {
      window.removeEventListener('resize', applyBg);
      body.style.backgroundImage = '';
    };
  }, [themeStatus, themeData]);

  const handleLogoClick = (e) => {
    if (!isFromMobileApp) return;
    e.preventDefault();
    window.GameStatus?.postMessage?.("navigate_back");
  };

  const handleBackClick = useCallback(
    (e) => {
      e.preventDefault();
      if (mainDaySubViewOpen) {
        dispatch(requestBackToMainGrid());
        return;
      }
      // From the game screens, Back returns to How to Play (the journey resumes from there).
      if (/^\/(play|vote)\/?$/.test(location.pathname)) {
        navigate('/rules');
        return;
      }

      const goToTarget = (path) => {
        if (!path) return false;
        if (/^https?:\/\//i.test(path)) {
          window.location.href = path;
          return true;
        }
        if (path.startsWith('/lobby')) {
          const base = String(process.env.REACT_APP_BASE_URL || '').replace(/\/$/, '');
          window.location.href = base ? `${base}${path}` : path;
          return true;
        }
        navigate(path);
        return true;
      };

      if (backUrl) {
        goToTarget(backUrl);
        return;
      }

      navigate('/login');
    },
    [backUrl, dispatch, mainDaySubViewOpen, navigate, location.pathname]
  );

  return (
    <>
      <header className="upperaction">
      <a href={process.env.REACT_APP_BASE_URL} onClick={handleLogoClick}><img src={logoUrl} className="logo-holder" alt="" /></a>
        {!isFromMobileApp && !backButtonHidden && (
          <div className="back-holder">
            {mainDaySubViewOpen ? (
              <button
                type="button"
                className="back-default"
                onClick={() => dispatch(requestBackToMainGrid())}
              >
                Back
              </button>
            ) : (
              <button type="button" className="back-default" onClick={handleBackClick}>
                Back
              </button>
            )}
          </div>
        )}
       
      </header>
      {children}
    </>
  );
}

export default USER;
